import React from 'react';
import { makeStyles, fade } from '@material-ui/core/styles';
import { Button, Card, CardContent, CardActionArea, CardActions, IconButton, Icon, Tooltip } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
	root: {
		cursor: 'pointer'
	},
	pos: {
		marginBottom: 12
	},
	imageIcon: {
		background: fade(theme.palette.secondary.main, 0.8),
		'&:hover': {
			background: fade(theme.palette.secondary.main, 1)
		}
	}
}));

function FilePickerImageItem(props) {
	const classes = useStyles();

	return (
		<Card className={classes.root} variant="outlined">
			<CardActionArea component="a" href={props.getUrl(props.item)} target="_blank">
				<CardContent className="p-0">
					<div className="w-full text-center relative h-192 border-b">
						<div className="w-full h-full bg-cover bg-center" style={{ backgroundImage: `url(${props.getUrl(props.item)})` }} />
						{props.selectable ? (
							<Tooltip title="Kiválasztás">
								<IconButton
									className={clsx(classes.imageIcon, 'absolute top-12 left-12')}
									onClick={e => {
										props.onSelectImage();
										e.preventDefault();
									}}
								>
									<Icon fontSize="small">present_to_all</Icon>
								</IconButton>
							</Tooltip>
						) : null}
					</div>
				</CardContent>
			</CardActionArea>
			<CardActions>
				<Button size="small" component="a" className="w-full text-center" href={props.getUrl(props.item)} target="_blank">
					<div dangerouslySetInnerHTML={{ __html: props.item.fileName.replaceAll('_', '_<wbr>') }} />
				</Button>
			</CardActions>
		</Card>
	);
}

export default FilePickerImageItem;
